import React, { Suspense, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  useHistory,
} from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import './helpers/Firebase';
import AppLocale from './lang';
import ColorSwitcher from './components/common/ColorSwitcher';
import { NotificationContainer } from './components/common/react-notifications';
import {
  isMultiColorActive,
  adminRoot,
  apiurl,
} from './constants/defaultValues';
import { getDirection } from './helpers/Utils';
import { ProtectedRoute } from './helpers/authHelper';
import axios from 'axios';

const ViewHome = React.lazy(() =>
  import(/* webpackChunkName: "views" */ './views/home')
);
const ViewApp = React.lazy(() =>
  import(/* webpackChunkName: "views-app" */ './views/app')
);
const ViewUser = React.lazy(() =>
  import(/* webpackChunkName: "views-user" */ './views/user')
);
const ViewError = React.lazy(() =>
  import(/* webpackChunkName: "views-error" */ './views/error')
);
const ViewUnauthorized = React.lazy(() =>
  import(/* webpackChunkName: "views-error" */ './views/unauthorized')
);

const App = ({ locale }) => {
  const direction = getDirection();
  const currentAppLocale = AppLocale[locale];
  const inactivityTimeout = useRef(null);

  // Moved useHistory inside Router context
  const AppContent = () => {
    const history = useHistory();

    useEffect(() => {
      const token = localStorage.getItem('token');
      const userRole = localStorage.getItem('role');
      console.log("user role => ", userRole)
      if (!token || !userRole) {
        history.push('/user/login');
      }
    }, [history]);

    // useEffect(() => {
    //   const resetInactivityTimeout = () => {
    //     if (inactivityTimeout.current) {
    //       clearTimeout(inactivityTimeout.current);
    //     }
    //     inactivityTimeout.current = setTimeout(logout, 15 * 60 * 1000);
    //   };

    //   const logout = async () => {
    //     try {
    //       console.log("logout due to inactivity");
    //       await axios.post(`${apiurl}/admin/adminLogout`);
    //       localStorage.clear();
    //       window.location.href = '/user/login';
    //     } catch (error) {
    //       console.error('Error logging out:', error);
    //     }
    //   };

    //   window.addEventListener('mousemove', resetInactivityTimeout);
    //   window.addEventListener('keydown', resetInactivityTimeout);
    //   resetInactivityTimeout();

    //   return () => {
    //     window.removeEventListener('mousemove', resetInactivityTimeout);
    //     window.removeEventListener('keydown', resetInactivityTimeout);
    //     clearTimeout(inactivityTimeout.current);
    //   };
    // }, []);

    return (
      <Switch>
        <ProtectedRoute
          path={adminRoot}
          component={ViewApp}
          roles={["superAdmin"]}
        />
        <Route path="/user" render={(props) => <ViewUser {...props} />} />
        <Route path="/error" exact render={(props) => <ViewError {...props} />} />
        <Route path="/unauthorized" exact render={(props) => <ViewUnauthorized {...props} />} />
        <Redirect exact from="/" to={adminRoot} />
        <Redirect to="/error" />
      </Switch>
    );
  };

  return (
    <div className="h-100">
      <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
        <>
          <NotificationContainer />
          {isMultiColorActive && <ColorSwitcher />}
          <Suspense fallback={<div className="loading" />}>
            <Router>
              <AppContent /> {/* Move AppContent inside Router */}
            </Router>
          </Suspense>
        </>
      </IntlProvider>
    </div>
  );
};

const mapStateToProps = ({ authUser, settings }) => {
  const { currentUser } = authUser;
  const { locale } = settings;
  return { currentUser, locale };
};
const mapActionsToProps = {};

export default connect(mapStateToProps, mapActionsToProps)(App);
